import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import jobsdashboardComponent from "./jobsdashboard.component";

let jobsdashboardModule = angular
  .module("jobsdashboard", [uiRouter, "ngStorage"])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider.state("jobsdashboard", {
      url: "/jobs-dashboard?filter&longTerm&dashboardType&action",
      template: "<jobsdashboard></jobsdashboard>",
      title: "Jobs",
      params: {
        filter: null,
        longTerm: null,
        dashboardType: null,
        action: null,
      },
    });
  })

  .component("jobsdashboard", jobsdashboardComponent);

export default jobsdashboardModule;



// WEBPACK FOOTER //
// ./client/app/components/jobsdashboard/jobsdashboard.js